module.exports = __webpack_public_path__ + "static/media/Bell_beaker_eba_wales.4695faec.png";